import Switchable from '../../../../../interface/Switchable.js';
import DIV from '../../../../DOM/div/DIV.js';
import BUTTON, { button } from '../../../../DOM/button/BUTTON.js';
import { makeAttrStruct } from '../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../enums/ModelData.js';
import { makeStruct } from '../../../../../enums/MODELS.js';
import { BUTTONTYPES } from '../../../../../enums/BUTTONTYPES.js';
import { span } from '../../../../DOM/span/SPAN.js';
import Activate from '../../../../../event/Activate.js';
import Clickable from '../../../../../interface/Clickable.js';
import Closeable from '../../../../../interface/Closeable.js';
import Deactivate from '../../../../../event/Deactivate.js';
import { BUTTONGROUP } from '../../../../DOM/dialog/DIALOG.js';
import { buttongroup } from '../../../../DOM/GROUP/buttongroup/BUTTONGROUP.js';
// Model Structure
export const tabAttr = makeAttrStruct([
    ['name'],
    ['title'],
    ['class'],
    ['disabled'],
    ['type', BUTTONTYPES.BUTTON]
]);
export const tabData = makeDataStruct([
    ['button'],
    ['buttons', []]
]);
export const tabModel = makeStruct([
    ['attributes', tabAttr],
    ['data', tabData]
]);
// Simplified Model
export function tab(text, icon, name, title, className, disabled) {
    return {
        attributes: tabAttr(name, title, className, disabled),
        data: tabData(button(span(text), name, icon))
    };
}
/** Button that can be switched on or off, and activates a target */
export default class TAB extends DIV {
    button;
    buttonGroup;
    constructor(node, model) {
        super(node, model);
        this.implement(new Clickable(this));
        this.implement(new Switchable(this));
        this.implement(new Closeable(this));
        this.addClass('tab');
        this.button = new BUTTON(this, model.data.button).addClass('btn-tab')
            .on('click', (ev) => this.do(new Activate(this.button)));
        this.on('activate', (ev) => this.button.do(new Activate(this)))
            .on('deactivate', (ev) => this.button.do(new Deactivate(this)))
            .on('close', (ev) => this.closeEvent(ev));
        this.buttonGroup = new BUTTONGROUP(this, buttongroup('buttons'));
    }
    /** Set Label */
    setLabel(label) {
        this.button.setLabel(label);
    }
}
